import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneConsentValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.get('consentEmail')?.value;
    const sms = control.get('consentSMS')?.value;
    return email || sms ? null : { atLeastOne: true };
  };
}
